import React, { FC, useState, SyntheticEvent } from 'react';
import { MAIN_SITE_LINK } from '../../../constants';
import {
    SearchSuggestionsTownsAndCitiesWrapper,
    TownsAndCitiesHeadlineWrapper,
    SectionWrapper,
    Section,
    LinkWrapper,
    SectionIcon,
    IconAndHeadingWrapper,
    SectionHeading,
    Divider,
    StyledButtonLinkWithIcon,
    StyledLink,
    TabButtons,
    TabButton,
    TabContent,
    ContentContainer,
    MobileLink,
    DesktopLink,
    StyledHeading,
    StyledArrowsWrapperMobile,
    StyledArrowsWrapperTablet,
    StyledImage
} from './SearchSuggestionsTownsAndCities.styles';
import {
    trackBrowseAllCitiesTownsUK,
    trackSeeAllUKForSale,
    trackSeeAllUKToRent,
    trackIndividualLocationForSale,
    trackIndividualLocationToRent
} from './SearchSuggestionsTownsAndCities.tracking';
import { ButtonIconOnly, Icon, Text } from '@blueprint/ui';
import { Heading3 } from '@blueprint/heading';
import { SearchSuggestionsTownsAndCitiesProps } from './SearchSuggestionsTownsAndCities.types';
import CityIcon from '../../../../public/Icons/City_icon.png';
import CoastIcon from '../../../../public/Icons/Coast_icon.png';
import CountrysideIcon from '../../../../public/Icons/Countryside_icon.png';
import PopularLocationsIcon from '../../../../public/Icons/Popular_locations_icon.png';
import { ArrowRightMedium, ArrowLeftMedium } from '@blueprint/icons';

type AreaId =
    | 'in-the-city'
    | 'on-the-coast'
    | 'rural-and-countryside'
    | 'popular-locations';

interface Item {
    type: string;
    headline: string;
    url: string;
}

interface Area {
    id: AreaId;
    headline: string;
    sub_headline: string;
    items: Item[];
}

const areas: Area[] = [
    {
        id: 'in-the-city',
        headline: 'In the city',
        sub_headline: 'Live among the hustle and bustle',
        items: [
            {
                type: 'for-sale',
                headline: 'London',
                url: 'https://www.zoopla.co.uk/for-sale/property/london/'
            },
            {
                type: 'to-rent',
                headline: 'London',
                url: 'https://www.zoopla.co.uk/to-rent/property/london/'
            },
            {
                type: 'for-sale',
                headline: 'Leeds',
                url:
                    'https://www.zoopla.co.uk/for-sale/property/west-yorkshire/leeds/'
            },
            {
                type: 'to-rent',
                headline: 'Aberdeen',
                url: 'https://www.zoopla.co.uk/to-rent/property/aberdeen/'
            },
            {
                type: 'for-sale',
                headline: 'Edinburgh',
                url: 'https://www.zoopla.co.uk/for-sale/property/edinburgh/'
            },
            {
                type: 'to-rent',
                headline: 'Edinburgh',
                url: 'https://www.zoopla.co.uk/to-rent/property/edinburgh/'
            },
            {
                type: 'for-sale',
                headline: 'Manchester',
                url: 'https://www.zoopla.co.uk/for-sale/property/manchester/'
            },
            {
                type: 'to-rent',
                headline: 'Manchester',
                url: 'https://www.zoopla.co.uk/to-rent/property/manchester/'
            },
            {
                type: 'for-sale',
                headline: 'Liverpool',
                url: 'https://www.zoopla.co.uk/for-sale/property/liverpool/'
            },
            {
                type: 'to-rent',
                headline: 'Liverpool',
                url: 'https://www.zoopla.co.uk/to-rent/property/liverpool/'
            },
            {
                type: 'for-sale',
                headline: 'Cardiff',
                url: 'https://www.zoopla.co.uk/for-sale/property/cardiff/'
            },
            {
                type: 'to-rent',
                headline: 'Cardiff',
                url: 'https://www.zoopla.co.uk/to-rent/property/cardiff/'
            }
        ]
    },
    {
        id: 'on-the-coast',
        headline: 'On the coast',
        sub_headline: 'Wake up to fresh air and sea views',
        items: [
            {
                type: 'for-sale',
                headline: 'Swansea',
                url: 'https://www.zoopla.co.uk/for-sale/property/swansea/'
            },
            {
                type: 'to-rent',
                headline: 'Swansea',
                url: 'https://www.zoopla.co.uk/to-rent/property/swansea/'
            },
            {
                type: 'for-sale',
                headline: 'Bristol',
                url: 'https://www.zoopla.co.uk/for-sale/property/bristol/'
            },
            {
                type: 'to-rent',
                headline: 'Bristol',
                url: 'https://www.zoopla.co.uk/to-rent/property/bristol/'
            },
            {
                type: 'for-sale',
                headline: 'Hull',
                url: 'https://www.zoopla.co.uk/for-sale/property/hull/'
            },
            {
                type: 'to-rent',
                headline: 'Hull',
                url: 'https://www.zoopla.co.uk/to-rent/property/hull/'
            },
            {
                type: 'for-sale',
                headline: 'Southampton',
                url: 'https://www.zoopla.co.uk/for-sale/property/southampton/'
            },
            {
                type: 'to-rent',
                headline: 'Southampton',
                url: 'https://www.zoopla.co.uk/to-rent/property/southampton/'
            },
            {
                type: 'for-sale',
                headline: 'Plymouth',
                url: 'https://www.zoopla.co.uk/for-sale/property/plymouth/'
            },
            {
                type: 'to-rent',
                headline: 'Plymouth',
                url: 'https://www.zoopla.co.uk/to-rent/property/plymouth/'
            },
            {
                type: 'for-sale',
                headline: 'Dundee',
                url: 'https://www.zoopla.co.uk/for-sale/property/dundee/'
            },
            {
                type: 'to-rent',
                headline: 'Dundee',
                url: 'https://www.zoopla.co.uk/to-rent/property/dundee/'
            }
        ]
    },
    {
        id: 'rural-and-countryside',
        headline: 'Rural and countryside',
        sub_headline: 'Enjoy living close to nature',
        items: [
            {
                type: 'for-sale',
                headline: 'Leicester',
                url: 'https://www.zoopla.co.uk/for-sale/property/leicester/'
            },
            {
                type: 'to-rent',
                headline: 'Leicester',
                url: 'https://www.zoopla.co.uk/to-rent/property/leicester/'
            },
            {
                type: 'for-sale',
                headline: 'Northampton',
                url: 'https://www.zoopla.co.uk/for-sale/property/northampton/'
            },
            {
                type: 'to-rent',
                headline: 'Northampton',
                url: 'https://www.zoopla.co.uk/to-rent/property/northampton/'
            },
            {
                type: 'for-sale',
                headline: 'Kent',
                url: 'https://www.zoopla.co.uk/for-sale/property/kent/'
            },
            {
                type: 'to-rent',
                headline: 'Kent',
                url: 'https://www.zoopla.co.uk/to-rent/property/kent/'
            },
            {
                type: 'for-sale',
                headline: 'Cornwall',
                url: 'https://www.zoopla.co.uk/for-sale/property/cornwall/'
            },
            {
                type: 'to-rent',
                headline: 'Derby',
                url: 'https://www.zoopla.co.uk/to-rent/property/derby/'
            },
            {
                type: 'for-sale',
                headline: 'Essex',
                url: 'https://www.zoopla.co.uk/for-sale/property/essex/'
            },
            {
                type: 'to-rent',
                headline: 'Essex',
                url: 'https://www.zoopla.co.uk/to-rent/property/essex/'
            },
            {
                type: 'for-sale',
                headline: 'Devon',
                url: 'https://www.zoopla.co.uk/for-sale/property/devon/'
            },
            {
                type: 'to-rent',
                headline: 'Devon',
                url: 'https://www.zoopla.co.uk/to-rent/property/devon/'
            }
        ]
    },
    {
        id: 'popular-locations',
        headline: 'Popular locations',
        sub_headline: 'Move to a property hotspot',
        items: [
            {
                type: 'for-sale',
                headline: 'Glasgow',
                url: 'https://www.zoopla.co.uk/for-sale/property/glasgow/'
            },
            {
                type: 'to-rent',
                headline: 'Glasgow',
                url: 'https://www.zoopla.co.uk/to-rent/property/glasgow/'
            },
            {
                type: 'for-sale',
                headline: 'Birmingham',
                url: 'https://www.zoopla.co.uk/for-sale/property/birmingham/'
            },
            {
                type: 'to-rent',
                headline: 'Birmingham',
                url: 'https://www.zoopla.co.uk/to-rent/property/birmingham/'
            },
            {
                type: 'for-sale',
                headline: 'Nottingham',
                url: 'https://www.zoopla.co.uk/for-sale/property/nottingham/'
            },
            {
                type: 'to-rent',
                headline: 'Nottingham',
                url: 'https://www.zoopla.co.uk/to-rent/property/nottingham/'
            },
            {
                type: 'for-sale',
                headline: 'Sheffield',
                url: 'https://www.zoopla.co.uk/for-sale/property/sheffield/'
            },
            {
                type: 'to-rent',
                headline: 'Sheffield',
                url: 'https://www.zoopla.co.uk/to-rent/property/sheffield/'
            },
            {
                type: 'for-sale',
                headline: 'Coventry',
                url: 'https://www.zoopla.co.uk/for-sale/property/coventry/'
            },
            {
                type: 'to-rent',
                headline: 'Coventry',
                url: 'https://www.zoopla.co.uk/to-rent/property/coventry/'
            },
            {
                type: 'for-sale',
                headline: 'Stoke-on-Trent',
                url:
                    'https://www.zoopla.co.uk/for-sale/property/stoke-on-trent/'
            },
            {
                type: 'to-rent',
                headline: 'Wolverhampton',
                url: 'https://www.zoopla.co.uk/to-rent/property/wolverhampton/'
            }
        ]
    }
];

const sectionIcon = (id: AreaId) => {
    switch (id) {
        case 'in-the-city':
            return CityIcon;
        case 'on-the-coast':
            return CoastIcon;
        case 'rural-and-countryside':
            return CountrysideIcon;
        case 'popular-locations':
            return PopularLocationsIcon;
        default:
            return null;
    }
};

enum Tab {
    ForSale = 'for-sale-tab',
    ToRent = 'to-rent-tab'
}

export const SearchSuggestionsTownsAndCities: FC<SearchSuggestionsTownsAndCitiesProps> = () => {
    const [selectedTabId, setSelectedTabId] = useState(Tab.ForSale);
    const [carouselIndex, setCarouselIndex] = useState(0);

    const isShowingForSale = selectedTabId === Tab.ForSale;
    const isShowingToRent = selectedTabId === Tab.ToRent;

    const decrementCarouselIndex = () => {
        setCarouselIndex((previousIndex) => previousIndex - 1);
    };

    const incrementCarouselIndex = () => {
        setCarouselIndex((previousIndex) => previousIndex + 1);
    };

    const sitemapLink = `${MAIN_SITE_LINK}/sitemap/`;
    const forSaleLink = `${MAIN_SITE_LINK}/for-sale/property/uk/`;
    const toRentLink = `${MAIN_SITE_LINK}/to-rent/property/uk/`;

    return (
        <SearchSuggestionsTownsAndCitiesWrapper>
            <TownsAndCitiesHeadlineWrapper>
                <StyledHeading size="5">
                    Discover towns and cities
                </StyledHeading>
            </TownsAndCitiesHeadlineWrapper>
            <ContentContainer>
                <TabButtons role="tablist">
                    <TabButton
                        href="/for-sale/"
                        role="tab"
                        aria-selected={isShowingForSale}
                        aria-controls="suggestions-content-for-sale"
                        id="suggestions-tab-for-sale"
                        isActive={isShowingForSale}
                        onClick={(event: SyntheticEvent) => {
                            event.preventDefault();
                            setSelectedTabId(Tab.ForSale);
                        }}
                        data-testid="for-sale-tab"
                    >
                        For sale
                    </TabButton>
                    <TabButton
                        role="tab"
                        aria-selected={isShowingToRent}
                        aria-controls="suggestions-content-to-rent"
                        id="suggestions-tab-to-rent"
                        isActive={isShowingToRent}
                        data-testid="to-rent-tab"
                        href="/to-rent/"
                        onClick={(event: SyntheticEvent) => {
                            event.preventDefault();
                            setSelectedTabId(Tab.ToRent);
                        }}
                    >
                        To rent
                    </TabButton>
                </TabButtons>

                <DesktopLink
                    href={sitemapLink}
                    variant="tertiary"
                    data-testid="explore_more-cta-desktop"
                    onClick={() => trackBrowseAllCitiesTownsUK}
                >
                    Explore more towns & cities
                </DesktopLink>

                <StyledArrowsWrapperMobile>
                    <ButtonIconOnly
                        disabled={carouselIndex === 0}
                        aria-label="Arrow left"
                        variant="tertiary"
                        iconOnly
                        data-testid={`arrow_full_left_mobile`}
                        onClick={decrementCarouselIndex}
                    >
                        <ArrowLeftMedium />
                    </ButtonIconOnly>
                    <ButtonIconOnly
                        disabled={carouselIndex === 3}
                        aria-label="Arrow right"
                        variant="tertiary"
                        iconOnly
                        data-testid={`arrow_full_right_mobile`}
                        onClick={incrementCarouselIndex}
                    >
                        <ArrowRightMedium />
                    </ButtonIconOnly>
                </StyledArrowsWrapperMobile>

                <StyledArrowsWrapperTablet>
                    <ButtonIconOnly
                        disabled={carouselIndex === 0}
                        aria-label="Arrow left"
                        variant="tertiary"
                        iconOnly
                        data-testid={`arrow_full_left_tablet`}
                        onClick={decrementCarouselIndex}
                    >
                        <ArrowLeftMedium />
                    </ButtonIconOnly>
                    <ButtonIconOnly
                        disabled={carouselIndex === 1}
                        aria-label="Arrow right"
                        variant="tertiary"
                        iconOnly
                        data-testid={`arrow_full_right_tablet`}
                        onClick={incrementCarouselIndex}
                    >
                        <ArrowRightMedium />
                    </ButtonIconOnly>
                </StyledArrowsWrapperTablet>

                <TabContent
                    role="tabpanel"
                    aria-labelledby="suggestions-tab-for-sale"
                    id="suggestions-content-for-sale"
                    isVisible={isShowingForSale}
                    carouselIndex={carouselIndex}
                >
                    {areas.map((area) => {
                        const forSale = area.items.filter(
                            (item: { type: string }) => item.type === 'for-sale'
                        );
                        return (
                            <React.Fragment key={area.id}>
                                <SectionWrapper>
                                    <SectionHeading>
                                        <SectionIcon>
                                            <StyledImage
                                                src={sectionIcon(area.id)}
                                                alt=""
                                            />
                                        </SectionIcon>
                                        <IconAndHeadingWrapper>
                                            <Heading3 size="5">
                                                {area.headline}
                                            </Heading3>
                                            <Text size="8">
                                                {area.sub_headline}
                                            </Text>
                                            {area.id === 'popular-locations' ? (
                                                <StyledLink
                                                    href={forSaleLink}
                                                    variant="tertiary"
                                                    data-testid="see_all_UK_ForSale"
                                                    onClick={() =>
                                                        trackSeeAllUKForSale()
                                                    }
                                                >
                                                    See all UK properties for
                                                    sale
                                                </StyledLink>
                                            ) : null}
                                        </IconAndHeadingWrapper>
                                    </SectionHeading>
                                    <Section>
                                        {forSale
                                            .slice(0, 3)
                                            .map(
                                                (item: {
                                                    headline: string;
                                                    url: string;
                                                }) => (
                                                    <LinkWrapper key={item.url}>
                                                        <StyledButtonLinkWithIcon
                                                            variant="tertiary"
                                                            data-testid={`city-living-link-${item.headline}`}
                                                            href={item.url}
                                                            onClick={() =>
                                                                trackIndividualLocationForSale(
                                                                    item.headline
                                                                )
                                                            }
                                                        >
                                                            <Icon
                                                                iconId="arrow_full_right"
                                                                size="small"
                                                            />
                                                            {item.headline}{' '}
                                                            properties for sale
                                                        </StyledButtonLinkWithIcon>
                                                    </LinkWrapper>
                                                )
                                            )}
                                    </Section>

                                    <Section>
                                        {forSale
                                            .slice(3, 6)
                                            .map(
                                                (item: {
                                                    headline: string;
                                                    url: string;
                                                }) => (
                                                    <LinkWrapper key={item.url}>
                                                        <StyledButtonLinkWithIcon
                                                            variant="tertiary"
                                                            data-testid={`city-living-link-${item.headline}`}
                                                            href={item.url}
                                                            onClick={() =>
                                                                trackIndividualLocationForSale(
                                                                    item.headline
                                                                )
                                                            }
                                                        >
                                                            <Icon
                                                                iconId="arrow_full_right"
                                                                size="small"
                                                            />
                                                            {item.headline}{' '}
                                                            properties for sale
                                                        </StyledButtonLinkWithIcon>
                                                    </LinkWrapper>
                                                )
                                            )}
                                    </Section>
                                </SectionWrapper>
                                {area.id !== 'popular-locations' ? (
                                    <Divider />
                                ) : null}
                            </React.Fragment>
                        );
                    })}
                </TabContent>

                <TabContent
                    role="tabpanel"
                    aria-labelledby="suggestions-tab-to-rent"
                    id="suggestions-content-to-rent"
                    isVisible={isShowingToRent}
                    carouselIndex={carouselIndex}
                >
                    {areas.map((area) => {
                        const toRent = area.items.filter(
                            (i: { type: string }) => i.type === 'to-rent'
                        );
                        return (
                            <React.Fragment key={area.id}>
                                <SectionWrapper>
                                    <SectionHeading>
                                        <SectionIcon>
                                            <StyledImage
                                                src={sectionIcon(area.id)}
                                                alt=""
                                            />
                                        </SectionIcon>
                                        <IconAndHeadingWrapper>
                                            <Heading3 size="5">
                                                {area.headline}
                                            </Heading3>
                                            <Text size="8">
                                                {area.sub_headline}
                                            </Text>
                                            {area.id === 'popular-locations' ? (
                                                <StyledLink
                                                    href={toRentLink}
                                                    variant="tertiary"
                                                    data-testid="see_all_UK_toRent"
                                                    onClick={() =>
                                                        trackSeeAllUKToRent()
                                                    }
                                                >
                                                    See all UK properties to
                                                    rent
                                                </StyledLink>
                                            ) : null}
                                        </IconAndHeadingWrapper>
                                    </SectionHeading>
                                    <Section>
                                        {toRent
                                            .slice(0, 3)
                                            .map(
                                                (item: {
                                                    headline: string;
                                                    url: string;
                                                }) => {
                                                    return (
                                                        <React.Fragment
                                                            key={item.url}
                                                        >
                                                            <LinkWrapper>
                                                                <StyledButtonLinkWithIcon
                                                                    variant="tertiary"
                                                                    data-testid={`city-living-link-${item.headline}`}
                                                                    href={
                                                                        item.url
                                                                    }
                                                                    onClick={() =>
                                                                        trackIndividualLocationToRent(
                                                                            item.headline
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon
                                                                        iconId="arrow_full_right"
                                                                        size="small"
                                                                    />
                                                                    {
                                                                        item.headline
                                                                    }{' '}
                                                                    properties
                                                                    to rent
                                                                </StyledButtonLinkWithIcon>
                                                            </LinkWrapper>
                                                        </React.Fragment>
                                                    );
                                                }
                                            )}
                                    </Section>
                                    <Section>
                                        {toRent
                                            .slice(3, 6)
                                            .map(
                                                (item: {
                                                    headline: string;
                                                    url: string;
                                                }) => {
                                                    return (
                                                        <React.Fragment
                                                            key={item.url}
                                                        >
                                                            <LinkWrapper>
                                                                <StyledButtonLinkWithIcon
                                                                    variant="tertiary"
                                                                    data-testid={`city-living-link-${item.headline}`}
                                                                    href={
                                                                        item.url
                                                                    }
                                                                    onClick={() =>
                                                                        trackIndividualLocationToRent(
                                                                            item.headline
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon
                                                                        iconId="arrow_full_right"
                                                                        size="small"
                                                                    />
                                                                    {
                                                                        item.headline
                                                                    }{' '}
                                                                    properties
                                                                    to rent
                                                                </StyledButtonLinkWithIcon>
                                                            </LinkWrapper>
                                                        </React.Fragment>
                                                    );
                                                }
                                            )}
                                    </Section>
                                </SectionWrapper>
                                {area.headline !== 'Popular locations' ? (
                                    <Divider />
                                ) : null}
                            </React.Fragment>
                        );
                    })}
                </TabContent>
            </ContentContainer>
            <MobileLink
                href={sitemapLink}
                variant="tertiary"
                data-testid="explore_more-cta-mobile"
                onClick={() => trackBrowseAllCitiesTownsUK()}
            >
                Explore more towns & cities
            </MobileLink>
        </SearchSuggestionsTownsAndCitiesWrapper>
    );
};
